
(function() {
  var result = { translations: { "en": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Actions" }, "tag": { "remove": "Remove tag" }, "Select": { "noResults": "No results found", "searchPlaceholder": "Search...", "clearSelections": "Clear selections" }, "ErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." }, "sessionId": { "prefix": "Session Id: " } }, "ProgressSteps": { "completedStep": "Completed step", "incompleteStep": "Incomplete step" }, "Paginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "Datagrid": { "noData": { "Title": "No data available", "Description": "There is no data available to display." }, "noResults": { "Title": "No results found", "Description": "Try adjusting your search and filters to find what you're looking for.", "ClearActionLabel": "Clear search and filters" }, "toolbar": { "selectedRows": { "one": "{{count}} row selected", "other": "{{count}} rows selected", "clearSelection": "Clear selection", "selectAll": "Select all {{totalRows}} rows" }, "search": { "placeholder": "Search", "label": "Search", "clearSearch": "Clear search" } }, "pagination": { "visibleRows": "{{visibleRows}} of {{totalRows}} results", "itemsPerPage": "Items per page", "countPerPage": { "one": "{{count}} per page", "other": "{{count}} per page" } }, "SkeletonGrid": { "loading": "Loading" }, "DataGridColumnManagementPanel": { "description": "Choose which properties to display as columns. Then, move properties up or down, or drag and drop, to change the order they will be displayed.", "removeAllColumns": "Remove all columns", "update": "Update", "cancel": "Cancel", "edit": "Edit columns" } } }, "ui": { "UIAbstractPageSection": { "page": "Page Section" }, "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next", "tip": "Use arrow keys to see other items" }, "UIColorSwatch": { "label": "Color picker {{value}}", "noColorLabel": "Color picker, no color selected." }, "UIButtonCollapser": { "dropdownLabel": "Actions" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" }, "UISideNav": { "navigationLandmark": "Secondary" }, "UISortTH": { "ascendingSort": "Ascending sort. Press to sort descending.", "descendingSort": "Descending sort. Press to sort ascending.", "pressToSort": "Press to sort." }, "autosizedTextInput": { "charactersRemaining": "{{value}} characters remaining" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" }, "datePicker": { "dateSelected": "{{date}} is selected.", "noDateSelected": "No date selected.", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date", "invalidDate": "Invalid date", "today": "Today", "clear": "Clear", "placeholder": { "month": "MM", "day": "DD", "year": "YYYY" }, "nextMonth": "Next month", "prevMonth": "Previous month" }, "dateRange": { "startDate": "Start date", "endDate": "End date", "endDateBeforeStartDate": "The end date must come after the start date.", "startDateAfterEndDate": "The start date must come before the end date.", "to": "to" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026and {{count}} more.", "loadMore": "Load more" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Add" }, "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading\u2026" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" }, "clearButton": "Clear input" }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option \u201C{{label}}\u201D", "plusMore": "+ {{count}} more", "andMore": "\u2026and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITable": { "selectableTableRow": { "toggleSelection": "Toggle selection of the row" } }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "en": "static-1.5175"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.5175",
    "ar-eg": "static-1.5175",
    "bg": "static-1.5175",
    "bn": "static-1.5175",
    "ca-es": "static-1.5175",
    "cs": "static-1.5175",
    "da": "static-1.5175",
    "de": "static-1.5175",
    "el": "static-1.5175",
    "en-gb": "static-1.5175",
    "en": "static-1.5175",
    "es-mx": "static-1.5175",
    "es": "static-1.5175",
    "et": "static-1.5175",
    "fi": "static-1.5175",
    "fr-ca": "static-1.5175",
    "fr": "static-1.5175",
    "he-il": "static-1.5175",
    "hi": "static-1.5175",
    "hr": "static-1.5175",
    "hu": "static-1.5175",
    "id": "static-1.5175",
    "it": "static-1.5175",
    "ja": "static-1.5175",
    "ko": "static-1.5175",
    "lt": "static-1.5175",
    "ms": "static-1.5175",
    "nl": "static-1.5175",
    "no": "static-1.5175",
    "pl": "static-1.5175",
    "pt-br": "static-1.5175",
    "pt-pt": "static-1.5175",
    "ro": "static-1.5175",
    "ru": "static-1.5175",
    "sk": "static-1.5175",
    "sl": "static-1.5175",
    "sv": "static-1.5175",
    "th": "static-1.5175",
    "tl": "static-1.5175",
    "tr": "static-1.5175",
    "uk": "static-1.5175",
    "vi": "static-1.5175",
    "zh-cn": "static-1.5175",
    "zh-hk": "static-1.5175",
    "zh-tw": "static-1.5175"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:en', {version: 'static-1.5175'}); }
})();



(function() {
  var result = { translations: { "en": { "placeholder": "placeholder" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-3.6585"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6585",
    "ar-eg": "static-3.6585",
    "bg": "static-3.6585",
    "bn": "static-3.6585",
    "ca-es": "static-3.6585",
    "cs": "static-3.6585",
    "da": "static-3.6585",
    "de": "static-3.6585",
    "el": "static-3.6585",
    "en-gb": "static-3.6585",
    "en": "static-3.6585",
    "es-mx": "static-3.6585",
    "es": "static-3.6585",
    "et": "static-3.6585",
    "fi": "static-3.6585",
    "fr-ca": "static-3.6585",
    "fr": "static-3.6585",
    "he-il": "static-3.6585",
    "hi": "static-3.6585",
    "hr": "static-3.6585",
    "hu": "static-3.6585",
    "id": "static-3.6585",
    "it": "static-3.6585",
    "ja": "static-3.6585",
    "ko": "static-3.6585",
    "lt": "static-3.6585",
    "ms": "static-3.6585",
    "nl": "static-3.6585",
    "no": "static-3.6585",
    "pl": "static-3.6585",
    "pt-br": "static-3.6585",
    "pt-pt": "static-3.6585",
    "ro": "static-3.6585",
    "ru": "static-3.6585",
    "sk": "static-3.6585",
    "sl": "static-3.6585",
    "sv": "static-3.6585",
    "th": "static-3.6585",
    "tl": "static-3.6585",
    "tr": "static-3.6585",
    "uk": "static-3.6585",
    "vi": "static-3.6585",
    "zh-cn": "static-3.6585",
    "zh-hk": "static-3.6585",
    "zh-tw": "static-3.6585"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-3.6585'}); }
})();



(function() {
  var result = { translations: { "en": { "hubPicker": { "name": "Name", "domain": "Domain", "users": "Users", "contacts": "Contacts", "products": "Products", "noFilteredResults": "Sorry, no accounts match your filter.", "hubsFailedToLoad": "There was an issue loading your account information. Please try again or select an account below.", "obscuredAccounts": { "title": "Some accounts require an additional login.", "description": "You'll be asked to log in with their identity providers if you try to access them." }, "noPortals": { "title": "Setup a new HubSpot portal", "descriptionOne": "You are not in any HubSpot portal. This could be because your portal was deactivated due to inactivity, or you were removed by an administrator.", "descriptionTwo": "Creating a new account is simple and easy.", "cta": "Create new account" }, "defaultBadge": "Default", "defaultButton": { "set": "Set as Default", "unset": "Unset as Default" }, "pinButton": { "pin": "Pin", "unpin": "Unpin" }, "openButton": "Open", "error": { "defaultPortal": { "setFailed": "There was a problem changing your default portal.", "deleteFailed": "There was a problem deleting your default portal.", "message": "Please refresh the page and try again." } } }, "hubRecommend": { "title": "Your accounts", "description": "Use these accounts instead of creating a new one.", "continueButton": "Continue with this account", "showRestButton": "View your other accounts", "defaultBadge": "Default" }, "error": { "noAccounts": { "description": "You have no accounts." }, "requestFailed": { "description": "We couldn't load your accounts. Try refreshing the page." } }, "minimalHubPicker": { "hub": "Hub ID: {{portalId}}" } } } };
  result.translationsLoaded = {
  "hub-pickers-lib": {
    "en": "static-1.11640"
  }
};
  result.translationsAvailable = {
  "hub-pickers-lib": {
    "da": "static-1.11640",
    "de": "static-1.11640",
    "en": "static-1.11640",
    "es": "static-1.11640",
    "fi": "static-1.11640",
    "fr": "static-1.11640",
    "it": "static-1.11640",
    "ja": "static-1.11640",
    "ko": "static-1.11640",
    "nl": "static-1.11640",
    "no": "static-1.11640",
    "pl": "static-1.11640",
    "pt-br": "static-1.11640",
    "sv": "static-1.11640",
    "th": "static-1.11640",
    "zh-cn": "static-1.11640",
    "zh-tw": "static-1.11640"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:hub-pickers-lib:en', {version: 'static-1.11640'}); }
})();



(function() {
  var result = { translations: { "en": { "main": { "pageTitle": "Accounts Dashboard Beta | HubSpot", "header": "HubSpot Accounts", "searchText": "Search accounts", "filterText": "Compare sessions:", "filterByWeek": "Week over week", "filterByMonth": "Month over month", "filterByThirtyDay": "Last 30 days" } } } };
  result.translationsLoaded = {
  "hub-picker-ui": {
    "en": "static-1.11660"
  }
};
  result.translationsAvailable = {
  "hub-picker-ui": {
    "da": "static-1.11660",
    "de": "static-1.11660",
    "en": "static-1.11660",
    "es": "static-1.11660",
    "fi": "static-1.11660",
    "fr": "static-1.11660",
    "it": "static-1.11660",
    "ja": "static-1.11660",
    "ko": "static-1.11660",
    "nl": "static-1.11660",
    "no": "static-1.11660",
    "pl": "static-1.11660",
    "pt-br": "static-1.11660",
    "sv": "static-1.11660",
    "th": "static-1.11660",
    "zh-cn": "static-1.11660",
    "zh-tw": "static-1.11660"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:hub-picker-ui:en', {version: 'static-1.11660'}); }
})();


